module.exports = __webpack_public_path__ + "/img/Quad-Custom-Footprint-CZLUiW.svg";